export enum DocumentState {
  None = 0,
  Indexed = 1,
  SendedOK = 2,
  SendedKO = 3,
}
